import React, { useContext, useState } from 'react'
import { Link, useParams, useLocation } from 'react-router-dom';
import { Grid, Box } from '@mui/material';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Carrossel from './../../Carrossel/Carrossel';
import Rodape from '../../Rodape/Rodape';
import Produtos_Cards from '../../Produtos_Cards/Produtos_Cards';
import Paginacoes from '../../Paginacao/Paginacao';
import Ordenacao from '../../Ordenacao/Ordenacao';
import { MyContext } from '../../../context/MyContext';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { setCookie, getCookie } from '../../../utils';
import { Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import PesquisarImagem from '../../../assets/img/pesquisar.svg';
import DetalhesBotoes from '../../../assets/img/detalhes.svg';

function Produtos() {
  let history = useHistory();
  const { paginaAtual, setPaginaAtual, paginaTotal, setPaginaTotal } = useContext(MyContext);
  const { produtos, setProdutos } = useContext(MyContext);
  const { ultimaPesquisaProdutos, setUltimaPesquisaProdutos } = useContext(MyContext);
  const { produtosOrdem } = useContext(MyContext);
  const { posicaoOrdem, setPosicaoOrdem } = useContext(MyContext);
  const { showLoading, setShowLoading } = useContext(MyContext);

  return (
    <div>
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      display="flex"
      columns={12}
    >      
      <Grid item xs={12}>
        <NavBarTop />
      </Grid>

      <Grid item xs={12}>
          <Paper elevation={3} sx={{ marginLeft:'20px', marginRight:'20px', marginTop:'20px', width:"100" }}>
          <div><Typography sx={{ marginTop:"10px", marginLeft:"10px", paddingTop:"20px", textAlign:"center", fontWeight:"bold" }}>Como Efetuar a Pesquisa dos Produtos Desejados:</Typography></div>

          <img src={PesquisarImagem} alt="NAFIL" style={{ width: '90%', height: 'auto', paddingTop:'20px' }} />

          <div><Typography variant="body1" sx={{ marginTop:"10px", textAlign:"left", marginLeft:"20px", paddingTop:"20px", marginBottom:"20px" }}>
          Para localizar o produto desejado, utilize o campo de pesquisa localizado acima no centro da página:<br/><br/>
             • Digite a descrição do produto e o veículo e clique ' Enter ' ou na ' Lupa ' imagem localizada acima a direita.<br/>
             • Você Também Pode Digitar:<br/>
             <ul>             
             <ol>
              <li>&nbsp;Número do fabricante: <b>OC90</b></li>
              <li>&nbsp;Número original da Montadora: <b>94632619</b></li>
              <li>&nbsp;Código de barras do produto: <b>7892415460370</b></li>
              <li>&nbsp;Fabricante: <b>METAL LEVE</b></li>
              <li>&nbsp;Ou ainda tudo misturando: <b>FILTRO OLEO CORSA OC90 METAL LEVE</b></li>
              </ol>
             </ul>
             Certifique-se de que todas as palavras estejam escritas corretamente e completas.<br/>
             Tente utilizar menos palavras-chave.<br/>             
             <span>É muito importante a verificação completa da aplicação de todo produto localizados, clicando em:<img src={DetalhesBotoes} alt="NAFIL"/></span><br/>
             Como interpretar os textos no detalhes da aplicação:<br/><br/>
             <Grid 
                   container
                   spacing={0}
                   direction="row"
                   alignItems="left"
                   justify="left"
                   display="flex"
                   columns={12}             
             >
              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px" }}><b>.../94</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>APLICADO EM VEÍCULOS ATÉ ANO DE 1994.</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>94/98</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>APLICADO EM VEÍCULOS ENTRE ANO DE 1994 ATÉ 1998.</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>94/...</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>APLICADO EM VEÍCULOS ANO DE 1994 EM DIANTE.</span></Grid>
              </Grid> 
             <br/>
             Verifique também a cilindrada do motor indentificando:<br/><br/>
             <Grid 
                   container
                   spacing={0}
                   direction="row"
                   alignItems="left"
                   justify="left"
                   display="flex"
                   columns={12}             
             >
              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px" }}><b>1.0</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>MOTOR 1.000 CILINDRADAS.</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>1.6</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>MOTOR 1.600 CILINDRADAS.</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>1.8</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>MOTOR 1.800 CILINDRADAS.</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>2.0</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>MOTOR 2.000 CILINDRADAS.</span></Grid>
              </Grid> 
              <br/>
              Verifique o lado desejado identificado como:<br/><br/>
              <Grid 
                   container
                   spacing={0}
                   direction="row"
                   alignItems="left"
                   justify="left"
                   display="flex"
                   columns={12}             
             >
              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px" }}><b>LE</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>LADO ESQUERDO ( MOTORISTA ).</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>ESQ</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>LADO ESQUERDO ( MOTORISTA ).</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>LD</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>LADO DIREITO ( CARONA ).</span></Grid>

              <Grid item xs={0.8}><span style={{color:"red", fontSize:"14px", marginLeft:"15px"}}><b>DIR</b></span></Grid>
              <Grid item xs={11.2}><span style={{ fontSize:"14px"}}>LADO DIREITO ( CARONA ).</span></Grid>
              </Grid> 
          <br/>
          Caso mesmo assim não localize ou possua dúvidas na aplicação correta entre em contato conosco.<br/><br/>
            </Typography></div>
            </Paper>
      </Grid>      
      <Grid item xs={12}>
        <Rodape />
      </Grid>
    </Grid>
    </div>
  )
}

export default Produtos